import React, { useEffect } from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'

//
const TransformToEmailNode = React.memo(
  ({ data, isConnectable }: BaseNodeProps<never>) => {
    const title = 'Transformer en mail'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'filter'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default TransformToEmailNode
